// "Invalid draft" protocol. A control whose visible text is not (yet) a valid value — MoneyInput
// "1.2.3" or above its max, NumberInput "abc", ColorPicker "#12" — keeps emitting nothing and marks
// its <input> with data-invalid-draft="<why>". useForm().submit and StickySaveBar refuse to save
// while such a control is on screen, so a form can never save a value different from what the
// merchant sees. Controls also commit their draft on Enter and ⌘S before the save runs.
import { toast } from './toast'

export const INVALID_DRAFT_ATTR = 'data-invalid-draft'

/** The first visible control (inside `root`) whose text isn't a valid value; null when all are. */
export function findInvalidDraft(root: ParentNode | null = typeof document === 'undefined' ? null : document): HTMLElement | null {
  if (!root) return null
  for (const el of root.querySelectorAll<HTMLElement>(`[${INVALID_DRAFT_ATTR}]`)) {
    if (el.isConnected && el.getClientRects().length > 0) return el
  }
  return null
}

/** Refuse to save while a control shows an invalid draft: focus it and say why. Returns true when blocked. */
export function blockOnInvalidDraft(root?: ParentNode | null): boolean {
  const el = findInvalidDraft(root ?? (typeof document === 'undefined' ? null : document))
  if (!el) return false
  el.focus({ preventScroll: true })
  el.scrollIntoView({ block: 'center', behavior: 'smooth' })
  toast.error(el.getAttribute(INVALID_DRAFT_ATTR) || 'Fix the highlighted field before saving.', { id: 'invalid-draft' })
  return true
}

/** True for the keys that commit a draft before a save runs: Enter and ⌘S / Ctrl+S. */
export const isCommitKey = (e: { key: string; metaKey: boolean; ctrlKey: boolean; altKey: boolean }) =>
  e.key === 'Enter' || ((e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === 's')
